import React, { useState, useEffect } from "react";
import "./PromoCode.css";
import {
  RiCheckboxBlankCircleFill,
  RiCheckboxBlankCircleLine,
} from "react-icons/ri";
import { RxCross2 } from "react-icons/rx";
import ViewMorePormo from "./ViewMorePormo";

const PromoCode = ({ availableCoupons = [], onSelectCoupon }) => {
  const [promoCode, setPromoCode] = useState("");
  const [appliedCode, setAppliedCode] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [showAllCoupons, setShowAllCoupons] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Detect screen width
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ⛔ Hide coupons with status === "1"
  const filteredCoupons = availableCoupons.filter((c) => c.sector !== "1");

  const handleSelectCoupon = (code) => {
    const selected = availableCoupons.find(
      (c) => c.coupon_code.toLowerCase() === code.toLowerCase()
    );

    if (selected) {
      setPromoCode(selected.coupon_code);
      setAppliedCode(selected.coupon_code);
      setMessage("Promo code applied successfully!");
      setError("");
      onSelectCoupon(selected);
      if (isMobile) setShowAllCoupons(false);
    }
  };

  const handleApply = () => {
    const found = availableCoupons.find(
      (c) => c.coupon_code.toLowerCase() === promoCode.trim().toLowerCase()
    );

    if (found) {
      setAppliedCode(found.coupon_code);
      setMessage("Promo code applied successfully!");
      setError("");
      onSelectCoupon(found);
    } else {
      setMessage("");
      setError("Promo code doesn't exist.");
    }
  };

  const handleRemove = () => {
    setPromoCode("");
    setAppliedCode("");
    setMessage("");
    setError("");
    onSelectCoupon(null);
  };

  // Show limited coupons in desktop collapsed mode
  const visibleCoupons =
    !showAllCoupons && !isMobile
      ? filteredCoupons.slice(0, 2)
      : filteredCoupons;

  return (
    <div>
      {/* ================= Desktop View ================ */}
      <div className="appendBottom20 offer_promoContainers_desktop">
        <div>
          <section className="promocodeWrap">
            <div>
              <div
                className="promoHeader"
                style={{
                  backgroundImage:
                    "linear-gradient(20deg, rgb(111 166 194) 20%, rgb(2 69 117) 100%)",
                }}
              >
                <span className="fontSize18">
                  <b>PROMO</b> CODES
                </span>
                <span className="promoIconWrapper appendLeft10">
                  <span
                    className="bgProperties iconPromoImg iconPromocode"
                    style={{
                      backgroundImage:
                        'url("https://imgak.goibibo.com/flights-gi-assets/dt/rta_assets/promo-code.png")',
                    }}
                  />
                </span>
              </div>

              <div className="appendBottom15 position-relative">
                <div className="promoInputWrapper">
                  <input
                    type="text"
                    className="promoInput"
                    placeholder="Enter promo code here"
                    value={promoCode}
                    onChange={(e) => setPromoCode(e.target.value)}
                    disabled={!!appliedCode}
                  />
                  {appliedCode ? (
                    <button
                      className="btn-remove-inline removew_promocode_desktop"
                      onClick={handleRemove}
                      title="Remove Promo Code"
                    >
                      <RxCross2 size={22} color="#1a4f87" />
                    </button>
                  ) : (
                    <button
                      className="btn-apply-inline"
                      onClick={handleApply}
                      title="Apply Promo Code"
                    >
                      Apply
                    </button>
                  )}
                </div>
                {message && <p className="clr-sucess fnt-12 mt-2">{message}</p>}
                {error && <p className="clr-error fnt-12 mt-2">{error}</p>}
              </div>

              <div className="appendBottom20">
                {visibleCoupons.map((coupon) => (
                  <div
                    key={coupon.id}
                    className="pointer promoContent"
                    style={{ backgroundColor: "rgb(242, 242, 242)" }}
                    onClick={() => handleSelectCoupon(coupon.coupon_code)}
                  >
                    <div className="flexOne cpn-wrapper">
                      <div className="makeFlex pointer gap-x-5 align-items-center">
                        <span className="radioWrap">
                          {appliedCode === coupon.coupon_code ? (
                            <RiCheckboxBlankCircleFill color="#2196f3" />
                          ) : (
                            <RiCheckboxBlankCircleLine color="#2196f3" />
                          )}
                        </span>
                        <div className="promoContentWrap flexOne">
                          <span className="couponCode">
                            {coupon.coupon_code}
                          </span>
                          <span
                            className="promoCheckContent"
                            dangerouslySetInnerHTML={{
                              __html: coupon.shortdescription,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

                {!isMobile && filteredCoupons.length > 2 && (
                  <div
                    className="fnt-14 shof clr-blue fnt-500"
                    onClick={() => setShowAllCoupons(!showAllCoupons)}
                    style={{ cursor: "pointer" }}
                  >
                    {showAllCoupons ? "View Less Coupons" : "View More Coupons"}
                  </div>
                )}
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* =============== Mobile View ================ */}
      <div className="offer_promoContainers_mobile">
        <div className="cpnbx">
          <div className="prmo_bxaht mr20">
            <div className="_tophecpn d-flex gap-20 align-items-center">
              <img
                src="/Images/promo-code.png"
                alt="Coupon Icon"
                style={{ width: "25px" }}
              />
              <div className="fnt-16 cblack fnt-600">
                Offers and Promo Codes
              </div>
              <img
                src="https://flight.easemytrip.com/M_Content/img/Icon-ionic-ios-arrow-back.svg"
                alt="right"
                style={{ marginLeft: "auto" }}
              />
            </div>

            <div className="cpn_mcoter">
              <div id="divCouponCodeApply">
                <div className="_fcpnentr d-flex justify-content-between align-items-center">
                  <input
                    className="f15"
                    id="txtCouponCode"
                    type="text"
                    placeholder="Enter Coupon Code"
                    value={promoCode}
                    onChange={(e) => setPromoCode(e.target.value)}
                    disabled={!!appliedCode}
                  />
                  {appliedCode ? (
                    <span
                      className="f13 wt600 clr-danger"
                      onClick={handleRemove}
                      style={{ cursor: "pointer" }}
                    >
                      Remove
                    </span>
                  ) : (
                    <span
                      className="f13 wt600 clr-blue"
                      onClick={handleApply}
                      style={{ cursor: "pointer" }}
                    >
                      Apply
                    </span>
                  )}
                </div>
              </div>

              {message && (
                <p className="clr-sucess fnt-12 mx-15 _msgBx">{message}</p>
              )}
              {error && (
                <p className="clr-error fnt-12 mx-15 _msgBx">{error}</p>
              )}

              <div className="cpon_chbx mt-10">
                {filteredCoupons.slice(0, 3).map((coupon) => (
                  <div key={coupon.id} className="coupn_colap">
                    <label className="radio-invrto lblnewCpn">
                      <div className="d-flex align-items-center">
                        <div className="fnt-600 cpn-n d-flex align-items-center">
                          {coupon.coupon_code}
                        </div>
                      </div>
                      <span className="z-con fnt-400">
                        {coupon.shortdescription}
                      </span>
                      <input
                        type="radio"
                        name="cpnRadio"
                        checked={appliedCode === coupon.coupon_code}
                        onChange={() => handleSelectCoupon(coupon.coupon_code)}
                      />
                      {appliedCode === coupon.coupon_code ? (
                        <RiCheckboxBlankCircleFill
                          className="checkmark-invrto"
                          color="#2196f3"
                        />
                      ) : (
                        <RiCheckboxBlankCircleLine
                          className="checkmark-invrto"
                          color="#2196f3"
                        />
                      )}
                    </label>
                  </div>
                ))}
                {filteredCoupons.length !== 0 && (
                  <div
                    className="fnt-14 shof clr-blue fnt-500"
                    onClick={() => setShowAllCoupons(true)}
                    style={{ cursor: "pointer" }}
                  >
                    View More Coupons
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {isMobile && showAllCoupons && (
        <ViewMorePormo
          handleSelectCoupon={handleSelectCoupon}
          availableCoupons={filteredCoupons}
          setShowAllCouponsModal={setShowAllCoupons}
          appliedCode={appliedCode}
          handleRemove={handleRemove}
          promoCode={promoCode}
          setPromoCode={setPromoCode}
        />
      )}
    </div>
  );
};

export default PromoCode;
